import axios from 'axios';

/**
 * Generic function to fetch data using Axios.
 * @param {string} URL - The endpoint to fetch data from.
 * @returns {Promise<any>} - The response data or throws an error.
 */
export const fetchData = async (url, config, setLoading, setError) => {
    try {
        const response = await axios.get(url, config);
        return response.data;
    } catch (err) {
        setError("Failed to fetch data.");
        return null;
    } finally {
        setLoading(false);
    }
};